<template>
  <div class="plan-container">
    <OnePricingPlan
      v-for="plan in plans"
      :key="plan.title"
      :plan="plan"
      :onPlanClick="handlePlanClick"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter } from 'vue-router';
import OnePricingPlan, { PLAN_NAMES } from "@/components/OnePricingPlan.vue";
import { Config } from "@/configs/config";
import { trackAndFlush } from "@/analytics/mixpanel";


export default defineComponent({
  name: "PricingPlans",
  components: {
    OnePricingPlan
  },
  props: {
    address: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const router = useRouter();
    
    const handlePlanClick = (plan) => {
      trackAndFlush("Plan Clicked", { plan_name: plan.planName });
      const queryParams = { plan: plan.planName };
      if (props.address) {
        queryParams.address = props.address;
      }
      router.push({ path: '/registration', query: queryParams });
    };

    return {
      handlePlanClick
    };
  },
  data() {
    return {
      plans: [
        {
          title: "Help us grow 🚀",
          price: "Free",
          buttonText: "Go with 🚀",
          planName: PLAN_NAMES.FREE,
          features: [
            { text: "State of the art AI models", isIncluded: true },
            { text: "Labeling cold outreach emails", isIncluded: true },
            { text: '"Inbox protected by inboxmaster.ai" in your signature', isIncluded: true }
          ]
        },
        {
          title: "Help us pay the bills 💰",
          price: `$${Config.MONTHLY_PRICE}/month`,
          buttonText: "Or maybe 💰",
          planName: PLAN_NAMES.PREMIUM,
          features: [
            { text: "State of the art AI models", isIncluded: true },
            { text: "Labeling cold outreach emails", isIncluded: true },
            { text: "Keep your signature as is", isIncluded: true }
          ]
        },
        {
          title: "If you like us, do both 🚀💰",
          price: `$${Config.MONTHLY_PRICE}/month`,
          buttonText: "The best one 🚀💰",
          planName: PLAN_NAMES.BOTH,
          features: [
            { text: "State of the art AI models", isIncluded: true },
            { text: "Labeling cold outreach emails", isIncluded: true },
            { text: "Promote us in your signature", isIncluded: true },
          ]
        }
      ]
    };
  }
});
</script>

<style scoped>
.plan-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

@media (max-width: 768px) {
  .plan-container {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .plan-container {
    gap: 12px;
  }
}
</style> 
